<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Información del Aporte
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            Ante cualquier duda, comuníquese con su promotor.
          </p> 
        </md-card-content> 
      </md-card>        

      <md-card class="md-elevation-0 m-5" :class="getValidationClass2('banco')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Banco de Origen de la Transferencia *
        </md-card-header>
        <md-card-content class="md-layout">

          <div class="md-layout-item md-layout">
            <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-15 md-small-size-25 md-xsmall-size-30">
              <md-checkbox v-model="form.banco" value="BCP" @change="ChangeOption">BCP</md-checkbox>
              <md-checkbox v-model="form.banco" value="Scotiabank" @change="ChangeOption">Scotiabank</md-checkbox>
              <md-checkbox v-model="form.banco" value="Interbank" @change="ChangeOption">Interbank</md-checkbox>
              <md-checkbox v-model="form.banco" :value="0" @change="ChangeOption">Otros</md-checkbox>
            </div>
            <div class="md-layout md-layout-item md-gutter md-alignment-bottom-left">
                <div class="md-layout-item">

                  <md-field class="md-field-aux" :class="getValidationClass('bancodes')">
                    <md-input type="text" name="otros" placeholder="Su respuesta" v-model="form.bancodes" :disabled="otros" autocomplete="off"/>
                    <span class="md-error" v-if="!$v.form.bancodes.required">Su respuesta es obligatoria.</span>
                    <span class="md-error" v-else-if="!$v.form.bancodes.alpha1">Formato inválido</span>
                    <span class="md-error" v-else-if="!$v.form.bancodes.minLength">Formato inválido</span>
                  </md-field>   

                </div>

            </div>

            <div class="radioform" :class="getValidationClass('banco')">
              <span class="md-error" v-if="!$v.form.banco.required">Esta respuesta es obligatoria.</span>
            </div>  

          </div>       

        </md-card-content> 
      </md-card>    

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('pais')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          País de Origen de la Transferencia *
        </md-card-header>
        <md-card-content>

          <div> 

              <ejs-dropdownlist ref="pa"  v-model="form.pais" 
              placeholder='Seleccione' 
              popupHeight='250px' sortOrder="Ascending" 
              :allowFiltering='allowFiltering' 
              :filtering='filtering' 
              :dataSource='pais' 
              :fields='fields'/>              


              <div class="radioform" :class="getValidationClass('pais')">
                <span class="md-error" v-if="!$v.form.pais.required">Su respuesta es obligatoria.</span>
              </div>

          </div>                     

        </md-card-content> 
      </md-card>    
      
      <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroCuenta')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Número de Cuenta de Origen *
        </md-card-header>
        <md-card-content>
          <div>  
            <md-field :class="getValidationClass('nroCuenta')">
              <md-input type="text" name="nroCuenta" placeholder="Su respuesta" v-model="form.nroCuenta" autocomplete="off" />
              <span class="md-error" v-if="!$v.form.nroCuenta.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-if="!$v.form.nroCuenta.alpha1">Formato inválido</span>
              <span class="md-error" v-if="!$v.form.nroCuenta.minLength">Formato inválido</span>
            </md-field>               
          </div>
        </md-card-content> 
      </md-card>               
      <!--
      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Adjuntar el voucher del depósito
        </md-card-header>
        <md-card-content>
          <div>
            <md-field>
              <md-file v-model="form.voucher" @md-change="uploadFile" accept="image/*, .pdf" multiple />
            </md-field>
          </div>
      
        </md-card-content> 
      </md-card>  
      --> 

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                


    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha1 } from '../variables'
import {
  required,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators'
import { Query } from "@syncfusion/ej2-data";

export default {
  mixins: [validationMixin],
  name: 'Form8',
  props:["pais"],
  data: () => ({
    form:{
    },
    query : new Query().select(['nacionalidad', 'idPais']).take(7),
    fields : { text: 'nacionalidad', value: 'nacionalidad' },
    allowFiltering: true,      
  }),
  mounted: function(){
    this.form = this.$store.state.form.form8
  },  
  validations: {
    form: {
      pais: {
        required,
      },
      nroCuenta: {
        required,
        alpha1,
        minLength: minLength(3)
      },
      banco: {
        required,
      },
      bancodes: {
        required: requiredIf(function(form){
          return (form.banco == "0")
        }),
        minLength: minLength(3),
        alpha1,
      }
    },
  },
  methods: {
    ChangeOption(item){
      if(item != "0"){
        this.form.bancodes = null;
      }
    },
    uploadFile(e){
      var data = new FormData();
      var that = this;
      var i = 0;
      Array.from(e).forEach(file => { 
        var name = ["File.", that.$route.params.id.toString(), ".", that.$options.name, ".", i, ".", file.name.split('.').pop()].join('')
        data.append('files', file, name);
        i++;
      });      
      
      that.$store.dispatch("saveImgFormulario", data)
      .then(()=> {

      })
      .catch(()=> { });      
         
    },   
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.form8
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {

        this.$emit('setSaveForm', {id:"8", form: this.form, index: "9"});

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
      
    },
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    },
    filtering: function(e) {
      var searchData = this.pais
      console.log(searchData)
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("nacionalidad", "startswith", e.text, true) : query;
      //pass the filter data source, filter query to updateData method.
      console.log(query)
      //e.updateData(searchData, query);
    }              
  },
  computed: {
    // a computed getter
    otros: function () {
      if(this.form.banco == "0"){
        //this.setOtros();
        return false;
      }
      return true;
    }
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
